/* @flow */

export {Percentage} from './percentage';
